export default "__VITE_ASSET__DAkgNGBD__"